<template>
  <div>
    <div class="mt-3">Solicitação Nº {{ idNotificacao }}</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <b-button
          class="border shadow-sm mr-2"
          variant="light"
          v-b-tooltip.hover="'Voltar'"
          @click="voltar()"
        >
          <font-awesome-icon icon="chevron-left" size="lg" fixed-width />
          <span class="align-middle">Voltar</span>
        </b-button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsVagas"
          :orderby="sortBy"
          :items="lstVagas"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
    <FccCadastroDescricoes
      :controlePage="controlePage"
      @visualizaFinalizar="visualizaFinalizar"
      :baseUrlPublicacao="baseUrlPublicacao"
    />
    <FccExportarVagas
      :controlePage="controlePage"
      :baseUrlPublicacao="baseUrlPublicacao"
      v-if="visualizaExportar"
      @exportaVagas="exportaVagas"
    />
    <FccFinalizaVagas
      :controlePage="controlePage"
      :baseUrlPublicacao="baseUrlPublicacao"
      v-if="visualizaExportar && permissao != null"
    />
  </div>
</template>
<script>
import axios from 'axios'
import FccCadastroDescricoes from './fccCadastroDescricoes.vue'
import FccExportarVagas from './fccExportarVagas.vue'
import FccFinalizaVagas from './fccFinalizaVagas.vue'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      sortBy: 'nome',
      itemPorPage: '1000',
      visualizaExportar: false,
      visualizaLiberar: false,
      lstVagas: [],
      permissao: {},
      fieldsVagas: [
        { key: 'respondente', label: 'Respondente', sortable: true },
        { key: 'datadaresposta', label: 'Data da Resposta', sortable: true },
        { key: 'aguardando', label: 'Aguardando', sortable: true },
        { key: 'statusfinal', label: 'Status' }
      ]
    }
  },
  components: { FccCadastroDescricoes, FccExportarVagas, FccFinalizaVagas },
  methods: {
    voltar() {
      this.$emit('zerarSolicitacao', 0)
    },
    visualizaFinalizar(status) {
      this.visualizaExportar = status
    },
    exportaVagas(status) {
      this.visualizaLiberar = status
    },
    listarVagas() {
      axios
        .get(
          this.baseUrlPublicacao +
            'Publicacao/ListarRespondenteTipoPublicacao/' +
            this.controlePage.spi +
            '/' +
            this.idNotificacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstVagas = response.data
          if (this.lstVagas.length > 0) {
            this.lstVagas.forEach(function (data) {
              data['statusfinal'] = data['status']
              delete data['status']
            })
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String
  },
  mounted() {
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')

    this.listarVagas()
  }
}
</script>
